export default __webpack_public_path__ + "media/fonts/hpsimplified_rg.woff";